import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatPhoneNumber'
})
export class FormatPhoneNumberPipe implements PipeTransform {

  transform(phoneNumberString) : any {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '+1');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    } else {
      return null;
    }  
  } 

}

@Pipe({
  name: 'safeFormatPhoneNumber'
})
export class SafeFormatPhoneNumberPipe implements PipeTransform {

  transform(phoneNumberString: string): string {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      const lastFour = match[4];
      return `XXX-XXX-${lastFour}`;
    } else {
      return 'Invalid Phone Number';
    }
  }
}

